import { createI18n } from 'vue-i18n'
import {languages} from '@/i18n/index'
import {defaultLocale} from '@/i18n/index'
//import { messages } from './plugins/translations'

//Create VueI18n instance with options
// setup localized messages
export const messages = Object.assign(languages)
export const i18n = createI18n({
    locale: navigator.language,
    allowComposition: true, // you need to specify that!
    globalInjection: true,
    fallbackLocale: defaultLocale,
    messages,
    silentTranslationWarn: true
})
